// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading {
  padding: var(--content-margin);
}

.container {
  height: 100%;
}

.form-section {
  padding-top: var(--content-margin);
  overflow-y: auto;
  flex: 0 0 auto;
}

.form-field {
  width: 240px;
}

.toolbar {
  gap: 8px;
}

.deploy-name {
  font-weight: 500;
}

.deploy-started {
  margin-left: 12px;
  font-size: 12px;
  opacity: 0.6;
}

app-dynamic-form {
  display: block;
  margin: 20px;
}

app-terminal {
  flex: 1;
  min-height: 200px;
  margin: 0 var(--content-margin) 40px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/models/deploy/deploy.component.scss"],"names":[],"mappings":"AAAA;EACE,8BAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,kCAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,QAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,iBAAA;EACA,eAAA;EACA,YAAA;AACF;;AAEA;EACE,cAAA;EACA,YAAA;AACF;;AAEA;EACE,OAAA;EACA,iBAAA;EACA,oCAAA;AACF","sourcesContent":[".loading {\n  padding: var(--content-margin);\n}\n\n.container {\n  height: 100%;\n}\n\n.form-section {\n  padding-top: var(--content-margin);\n  overflow-y: auto;\n  flex: 0 0 auto;\n}\n\n.form-field {\n  width: 240px;\n}\n\n.toolbar {\n  gap: 8px;\n}\n\n.deploy-name {\n  font-weight: 500;\n}\n\n.deploy-started {\n  margin-left: 12px;\n  font-size: 12px;\n  opacity: 0.6;\n}\n\napp-dynamic-form {\n  display: block;\n  margin: 20px;\n}\n\napp-terminal {\n  flex: 1;\n  min-height: 200px;\n  margin: 0 var(--content-margin) 40px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
